// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-row[data-v-05b6ca15]{background:#fff;overflow:hidden}.header-row .header-box[data-v-05b6ca15]{align-items:center;display:flex;justify-content:space-between;margin:0 auto;padding:21px 0;width:1200px}.header-row .header-box .logo[data-v-05b6ca15]{background:url(/images/index/index-logo.png) 50% no-repeat;background-size:100% 100%;display:block;height:63px;margin-right:88px;width:377px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
